import React from 'react'
import PropTypes from 'prop-types'
import AutosuggestHighlightMatch from 'autosuggest-highlight/match'
import AutosuggestHighlightParse from 'autosuggest-highlight/parse'
import { SearchIcon, HistoryIcon, UserIcon } from '../icons'
import Link from '../Link'
import { Level, LevelLeft, LevelItem, IconWrapper } from '../../bulma'

/**
* TypeaheadSuggestion component to be used with the `SearchTypeahead` and `Typeahead`
* components.
*/
function TypeaheadSuggestion(props) {
  const { suggestion, query, ...rest } = props

  // Determine what text will be displayed and highlighted.
  const suggestionText = suggestion.label.trim()
  const matches = AutosuggestHighlightMatch(suggestionText, query)
  const parts = AutosuggestHighlightParse(suggestionText, matches)
  const href = suggestion.slug || `/products?keywords=${suggestion.value}`

  // Figure out if there's an icon associated with this suggestion.
  let icon = false

  if (suggestion.type === 'group') {
    icon = <SearchIcon iconColor="light" />
  } else if (suggestion.type === 'history') {
    icon = <HistoryIcon iconColor="light" />
  } else if (suggestion.crumbs && (suggestion.crumbs.indexOf('Author') > -1 || suggestion.crumbs.indexOf('Artist') > -1)) {
    icon = <UserIcon iconColor="light" />
  }

  /**
  * Renders the main display label for the suggestion.
  */
  const renderLabel = () => parts.map((part, idx) => (
    <span className={part.highlight ? 'is-strong' : ''} key={idx}>{part.text}</span>
  ))

  /**
  * Renders the taxon breadcrumb if one is present.
  */
  const renderBreadcrumbs = () => {
    if (!suggestion.crumbs || !suggestion.crumbs.length) {
      return false
    }

    return (
      <LevelItem>
        <div className="taxon-breadcrumb">
          {suggestion.crumbs.map((crumb, idx) => <span key={idx}>{crumb}</span>)}
        </div>
      </LevelItem>
    )
  }

  return (
    <Link href={href} className="suggestion-content">
      <Level isMobile className={`is-${suggestion.type || 'default'}`}>
        <LevelItem isNarrow className="is-marginless">
          <IconWrapper isMedium>
            {icon}
          </IconWrapper>
        </LevelItem>
        <LevelItem>
          <Level isMobile isFullwidth>
            <LevelLeft>
              <LevelItem className="highlights">
                {renderLabel()}
              </LevelItem>
              {renderBreadcrumbs()}
            </LevelLeft>
          </Level>
        </LevelItem>
      </Level>
    </Link>
  )
}

TypeaheadSuggestion.defaultProps = {
  query: '',
}

TypeaheadSuggestion.propTypes = {
  // Suggestion to be rendered.
  suggestion: PropTypes.object.isRequired,
  // Current query string.
  query: PropTypes.string,
}

export default TypeaheadSuggestion
